import { combineReducers } from 'redux';
import type { Action } from 'state/actions';
import { essentialWorkspacesReducer } from 'state/workspaces/essential/reducer';
import { secondaryMarketBatchReducer } from 'state/workspaces/secondary-market/batch/reducer';
import { secondaryMarketPostEventReducer } from 'state/workspaces/secondary-market/post-event/secondaryMarketPostEvent.reducer';
import { secondaryMarketQuotesReducer } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.reducer';
import { smartQuoteWorkspaceReducer } from 'state/workspaces/smart-quote/reducer';

import { addonManagementWorkspacesReducer } from './addonManagement/addonManagement.reducer';
import { batchWorkspaceReducer } from './batch/batch.reducer';
import { dynamicWorkspacesReducer } from './dynamic/dynamic.reducer';
import { ordersBasketWorkspaceReducer } from './ordersBasket/ordersBasket.reducer';
import { staticWorkspacesReducer } from './static/static.reducer';
import { tabsReducer } from './tabs/tabs.reducer';
import type { WorkSpaceState } from './workspaces.model';
import { workspacesReducer as workspacesSubdomainReducer } from './workspaces/workspaces.reducer';

export const workspacesReducer = combineReducers<WorkSpaceState, Action>({
  workspaces: workspacesSubdomainReducer,
  tabs: tabsReducer,
  static: staticWorkspacesReducer,
  essential: essentialWorkspacesReducer,
  dynamic: dynamicWorkspacesReducer,
  newBatch: batchWorkspaceReducer,
  ordersBasket: ordersBasketWorkspaceReducer,
  secondaryMarketBatch: secondaryMarketBatchReducer,
  secondaryMarketQuotes: secondaryMarketQuotesReducer,
  secondaryMarketPostEvents: secondaryMarketPostEventReducer,
  addonManagement: addonManagementWorkspacesReducer,
  smartQuote: smartQuoteWorkspaceReducer,
});
